// Resize
$(window).on("resize", function () {

});


// Scroll
$(window).on("scroll", function () {

})


//accordion//
document.addEventListener('DOMContentLoaded', function() {
	// Получаем все элементы аккордеона
	var accordionItems = document.querySelectorAll('.accordion-block-item');

	// Перебираем каждый элемент аккордеона
	accordionItems.forEach(function(item) {
		// Находим заголовок и контент для текущего элемента
		var header = item.querySelector('.accordion-block-item-header');
		var content = item.querySelector('.accordion-block-item-content');
		var btn = item.querySelector('.accordion-block-item-toggle'); // Правильный селектор для кнопки

		// Проверяем, что заголовок, контент и кнопка существуют
		if (header && content && btn) {
			// Добавляем обработчик клика для заголовка
			header.addEventListener('click', function() {
				// Переключаем видимость контента при клике на заголовок
				content.classList.toggle('active');
				btn.classList.toggle('active'); // Также переключаем класс у кнопки
			});
		}
	});
});
//accordion//

// Document click
$(document).on("click", function (e) {

});
let catalogBtn = document.querySelector('.header-main__info-block-item-btn');
let menuCatalog = document.querySelector('.header-main__info-block-catalog-main-list');
let menuBtn = document.querySelector('.header-main__info-burger');
let menu = document.querySelector('.header-main__info-block');
// // let telBtn = document.querySelector('.tel-btn-more');
// let menuTel = document.querySelector('.header-main-info-social-list');
let body = document.querySelector('body');

// Открытие/закрытие меню
menuBtn.addEventListener('click', function () {
    menuBtn.classList.toggle('active');
    menu.classList.toggle('active');
    body.classList.toggle('no-scroll');
});

// Открытие/закрытие каталога
catalogBtn.addEventListener('click', function () {
    catalogBtn.classList.toggle('active');
    menuCatalog.classList.toggle('active');
});

// // Открытие/закрытие списка телефонов
// telBtn.addEventListener('click', function () {
//     telBtn.classList.toggle('active');
//     menuTel.classList.toggle('active');
// });

// Функция проверки размера экрана
function checkScreenSize() {
    if (window.innerWidth > 768) {
        menuBtn.classList.remove('active');
        menu.classList.remove('active');
        catalogBtn.classList.remove('active');
        menuCatalog.classList.remove('active');
        // telBtn.classList.remove('active');
        // menuTel.classList.remove('active');
        body.classList.remove('no-scroll');
    }
}

// Проверка при загрузке страницы
checkScreenSize();

// Проверка при изменении размера экрана
window.addEventListener('resize', checkScreenSize);

// Закрытие всех активных блоков при клике вне их области
document.addEventListener('click', function (event) {
    if (!menuCatalog.contains(event.target) && !catalogBtn.contains(event.target)) {
        catalogBtn.classList.remove('active');
        menuCatalog.classList.remove('active');
    }
    if (!menuTel.contains(event.target) && !telBtn.contains(event.target)) {
        telBtn.classList.remove('active');
        menuTel.classList.remove('active');
    }
});


document.addEventListener("DOMContentLoaded", function() {
	var menuLists = document.querySelectorAll('.footer-block-menu-list');
	menuLists.forEach(function(list) {
	  if (list.children.length > 6) {
		list.classList.add('two-columns');
	  }
	});
});

// popups
$(".popup__close, .popup__cancel").on("click", function (e) {
	$("body").removeClass("no-scroll");
	$(this).closest(".popup").removeClass("active");
});

$(".popup").on("click", function (e) {
	var callbackPopup = $(".popup__card")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(this).removeClass("active");
		$("body").removeClass("no-scroll");
	};
});

$("[data-popup-open]").on("click", function (e) {
	e.preventDefault();
	let dataPopupName = $(this).attr("data-popup-open");
	let popup = $(".popup[data-popup-name=" + dataPopupName + "]");
	$("body").addClass("no-scroll");
	popup.addClass("active");
});

//PREVIEW//
if ($(window).width() <= 768) {
	$('.preview-block').addClass('no-click');
}

$(document).ready(function() {
	// Обработчик события клика по блоку
	$('.preview-block').on('click', function() {
		// Удаляем класс no-click после первого клика на мобильном устройстве
		$(this).removeClass('no-click');
	});
});
//PREVIEW//

//MAPS//
$('.mapContainer').each(function() {
	var mapTitle = $('<div>').addClass('mapTitle');
	mapTitle.text('Для активации карты нажмите по ней');
	$(this).append(mapTitle);

	$(this).on('click', function() {
		$(this).children(':first').removeAttr('style');
		mapTitle.remove();
	});

	$(this).on('mousemove', function(event) {
		mapTitle.css('display', 'block');
		if (event.offsetY > 10) mapTitle.css('top', event.offsetY + 20 + 'px');
		if (event.offsetX > 10) mapTitle.css('left', event.offsetX + 20 + 'px');
	});

	$(this).on('mouseleave', function() {
		mapTitle.css('display', 'none');
	});
});
//MAPS//

//preview slider//
$(document).ready(function() {
	function initializePreviewSwiper() {
		if (document.querySelector('.preview-slider-main')) {
			if (window.innerWidth >= 768) {
				if (!window.previewSwiperInstance) {
					// Инициализация Swiper
					window.previewSwiperInstance = new Swiper(".preview-slider-main", {
						spaceBetween: 24,
						navigation: {
							nextEl: ".preview-slider-btn-next",
							prevEl: ".preview-slider-btn-prev",
						},
						pagination: {
							el: ".preview-pagination",
							type: "fraction",
						},
						thumbs: {
							swiper: new Swiper(".preview-slider-img", {
								spaceBetween: 24,
								slidesPerView: 1,
								freeMode: true,
								watchSlidesProgress: true,
							}),
						},
					});
				} else {
					// Отложенное обновление Swiper через 100 мс
					setTimeout(() => {
						if (window.previewSwiperInstance) {
							window.previewSwiperInstance.update();
						}
					}, 100);
				}
			} else if (window.previewSwiperInstance) {
				// Отложенное уничтожение Swiper через 100 мс
				setTimeout(() => {
					if (window.previewSwiperInstance && document.querySelector('.preview-slider-main')) {
						window.previewSwiperInstance.destroy(true, true);
						window.previewSwiperInstance = null;
					}
				}, 100);
			}
		}
	}

	// Инициализация при загрузке страницы
	window.addEventListener('load', initializePreviewSwiper);
	// Инициализация при изменении размера окна
	window.addEventListener('resize', initializePreviewSwiper);
	// Инициализация при смене ориентации экрана
	window.addEventListener('orientationchange', initializePreviewSwiper);
});
//preview slider//

//catalog slider//
$(document).ready(function() {
	function initializeCatalogSwiper() {
		if (document.querySelector('.card-slider-block')) {
			if (window.innerWidth >= 768) {
				if (!window.catalogSwiperInstance) {
					// Инициализация Swiper
					window.catalogSwiperInstance = new Swiper(".card-slider-block", {
						pagination: {
							el: ".card-slider-pagination",
							type: "progressbar",
						},
						spaceBetween: 12,
						slidesPerView: 1.5,
						navigation: {
							nextEl: ".catalog-swiper-btn-next",
							prevEl: ".catalog-swiper-btn-prev",
						},
						breakpoints: {
							768: {
								slidesPerView: 3.5,
							},
							1024: {
								slidesPerView: 4.5
							},
							1280: {
								slidesPerView: 5.5
							}
						}
					});
				} else {
					// Отложенное обновление Swiper через 100 мс
					setTimeout(() => {
						if (window.catalogSwiperInstance) {
							window.catalogSwiperInstance.update();
						}
					}, 100);
				}
			} else if (window.catalogSwiperInstance) {
				// Отложенное уничтожение Swiper через 100 мс
				setTimeout(() => {
					if (window.catalogSwiperInstance && document.querySelector('.card-slider-block')) {
						window.catalogSwiperInstance.destroy(true, true);
						window.catalogSwiperInstance = null;
					}
				}, 100);
			}
		}
	}

	// Инициализация при загрузке страницы
	window.addEventListener('load', initializeCatalogSwiper);
	// Инициализация при изменении размера окна
	window.addEventListener('resize', initializeCatalogSwiper);
	// Инициализация при смене ориентации экрана
	window.addEventListener('orientationchange', initializeCatalogSwiper);
});
//catalog slider//

//example slider//
$(document).ready(function() {
	function initializeExampleSwiper() {
		if (document.querySelector('.example-slider')) {
			if (window.innerWidth >= 768) {
				if (!window.exampleSwiperInstance) {
					// Инициализация Swiper
					window.exampleSwiperInstance = new Swiper(".example-slider", {
						navigation: {
							nextEl: ".example-slider-btn-next",
							prevEl: ".example-slider-btn-prev",
						},
						spaceBetween: 12,
						slidesPerView: 1.5,
						breakpoints: {
							768: {
								slidesPerView: 3.5,
							},
							1024: {
								slidesPerView: 4.5
							},
							1280: {
								slidesPerView: 5.5
							}
						}
					});
				} else {
					// Отложенное обновление Swiper через 100 мс
					setTimeout(() => {
						if (window.exampleSwiperInstance) {
							window.exampleSwiperInstance.update();
						}
					}, 100);
				}
			} else if (window.exampleSwiperInstance) {
				// Отложенное уничтожение Swiper через 100 мс
				setTimeout(() => {
					if (window.exampleSwiperInstance && document.querySelector('.example-slider')) {
						window.exampleSwiperInstance.destroy(true, true);
						window.exampleSwiperInstance = null;
					}
				}, 100);
			}
		}
	}

	// Инициализация при загрузке страницы
	window.addEventListener('load', initializeExampleSwiper);
	// Инициализация при изменении размера окна
	window.addEventListener('resize', initializeExampleSwiper);
	// Инициализация при смене ориентации экрана
	window.addEventListener('orientationchange', initializeExampleSwiper);
});
//example slider//

//reviews slider//
var swiper = new Swiper(".reviews-slider", {
	pagination: {
		el: ".reviews-pagination",
		type: "progressbar",
	},
	spaceBetween: 12,
	navigation: {
		nextEl: ".reviews-slider-btn-next",
		prevEl: ".reviews-slider-btn-prev",
	},
	breakpoints: {
		480: {
			slidesPerView: 2
		},
		768: {
			slidesPerView: 3.5
		},
		1280: {
			slidesPerView: 5
		}
	}
});
//reviews slider//

//steps-slider//
var swiper = new Swiper(".steps-slider", {
	pagination: {
		el: ".steps-pagination",
		type: "fraction",
	},
	spaceBetween: 12,
	navigation: {
		nextEl: ".steps-btn-next",
		prevEl: ".steps-btn-prev",
	},
	//- breakpoints: {
	//- 	480: {
	//- 		slidesPerView: 2
	//- 	},
	//- 	768: {
	//- 		slidesPerView: 3.5
	//- 	},
	//- 	1280: {
	//- 		slidesPerView: 5
	//- 	}
	//- }
});
//steps-slider//

//slider-image//
var swiper = new Swiper(".slider-image-swiper", {
	pagination: {
		el: ".reviews-pagination",
		type: "progressbar",
	},
	spaceBetween: 12,
	slidesPerView: 1,
	navigation: {
		nextEl: ".slider-image-slider-btn-next",
		prevEl: ".slider-image-slider-btn-prev",
	},
	breakpoints: {
		480: {
			slidesPerView: 1.5
		},
		768: {
			slidesPerView: 3.5
		},
		1280: {
			slidesPerView: 4.5
		}
	}
});
//slider-image//